import { Segment } from 'component/Space/Segment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import Breast1 from 'page/ProfileScreen/assets/breasts-1.svg'
import Breast2 from 'page/ProfileScreen/assets/breasts-2.svg'
import Breast3 from 'page/ProfileScreen/assets/breasts-3.svg'
import Breast4 from 'page/ProfileScreen/assets/breasts-4.svg'
import { ReactElement } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { BustIndex } from 'type/Identity'

type Props = {
  bust: BustIndex
}

function getBustImage(bust: BustIndex): ReactElement | undefined {
  const height = opt.stand ? 48 : 32

  if (bust === 1) return <Breast1 height={height} width={24} />
  if (bust === 2) return <Breast2 height={height} width={24} />
  if (bust === 3) return <Breast3 height={height} width={24} />
  if (bust === 4) return <Breast4 height={height} width={24} />
}

export const BustSizeButton = observer(({ bust }: Props) => {
  const { form } = store.profile

  const onClick = useLatestCallback(() => {
    form.setBust(bust)
  })

  return <Segment height={opt.stand ? 60 : opt.tsum ? 48 : 40} active={form.bust === bust} action={onClick}>
    {getBustImage(bust)}
  </Segment>
})
